export var MIN_PERCENTILE = 0;
export var MAX_PERCENTILE = 100;
export var HIDE_TIME = 3000;